import React, { Component } from 'react';
import './cisFeed.css';
import cisLogo from '../../../../images/cisLogo.png';

class cisFeed extends Component {

  state = {
    threatLevel: '...',
    threatColor: '...',
    threatDescription: '...'
  };

  componentDidMount() {
    fetch('https://feeds.cisecurity.org/text?keys=level,color,description')
    .then(res => {
      return res.text();
    })
    .then(res => {
      const threatLevel = res.split('\r\n')[0].toUpperCase();
      const threatColor = res.split('\r\n')[1].toUpperCase();
      const threatDescription = res.split('\r\n')[2];
      this.setState({threatLevel, threatColor, threatDescription});
    });
  };

  levels = [
    {
      color: 'GREEN',
      level: 'LOW'
    },
    {
      color: 'BLUE',
      level: 'GUARDED'
    },
    {
      color: 'YELLOW',
      level: 'ELEVATED'
    },
    {
      color: 'ORANGE',
      level: 'HIGH'
    },
    {
      color: 'RED',
      level: 'SEVERE'
    },
  ]

  render() {

    return (
      <div className="cisFeedPage">
        <div className="cisPageFeedTitle">
          <img alt="CIS Logo" src={cisLogo}></img><h1>CIS Threat Level</h1>
        </div>
        <div className="cisPageFeedContent">
          <div className="cisPageFeedAlertLevels">
            {this.levels.map(level => {
              console.log();
              return (
                <div key={level.level} className={`cisPageCOLOR cisPage${level.color}${level.color !== this.state.threatColor ? ' cisPageOFF' : ''}`}>
                  <h1>{level.color}</h1><h1>{level.level}</h1>
                </div>
              );
            })}
          </div>
          <div className="cisPageFeedDescription">
            <p>{this.state.threatDescription}</p>
          </div>
        </div>
      </div>
    );

  };

};

export default cisFeed;


// WEBPACK FOOTER //
// ./src/components/content/securityFeeds/cisFeed/cisFeed.js